import Actions from '../actions/actions';
import { NetworkState } from '../interfaces/network';

const initialState: NetworkState = {
  facebookConnectModal: {
    message: '',
    show: false,
  },
  widgetErrorModal: {
    show: false,
    message: '',
  },
};

const toggleFBConnectModal = (state, action, isShown) => ({
  ...state,
  facebookConnectModal: {
    ...action.payload,
    show: isShown,
  },
});

const toggleWidgetErrorModal = (state, action, isShown) => ({
  ...state,
  widgetErrorModal: {
    ...action.payload,
    show: isShown,
  },
});

export default function network(state = initialState, action) {
  switch (action.type) {
    case Actions.SHOW_FACEBOOK_CONNECT_MODAL:
      return toggleFBConnectModal(state, action, true);
    case Actions.HIDE_FACEBOOK_CONNECT_MODAL:
      return toggleFBConnectModal(state, action, false);
    case Actions.SHOW_WIDGET_ERROR_MODAL:
      return toggleWidgetErrorModal(state, action, true);
    case Actions.HIDE_WIDGET_ERROR_MODAL:
      return toggleWidgetErrorModal(state, action, false);
    default: {
      return state;
    }
  }
}
